import React, { Component } from "react";
import PropTypes from "prop-types";
import {
  Row,
  Col,
  Checkbox,
  Button,
  FormGroup,
  FormControl,
  ControlLabel,
  InputGroup,
  Glyphicon,
  Image,
  Alert,
  Tabs,
  Tab,
  Table,
} from "react-bootstrap";
import { connect } from "react-redux";
import { bindActionCreators, compose } from "redux";
import { createBrowserHistory } from "history";
import { withRouter, Link } from "react-router-dom";
import ReactHtmlParser from "react-html-parser";
import isEmpty from "lodash.isempty";
import Pagination from "react-paginating";
import NumberFormat from "react-number-format";
import { voucherStatus ,partnerPermission} from "../../../redux/actions/frontActions";
import "../dashboard/dashboard.scss";
import ReactAutocomplete from "react-autocomplete";
import "react-responsive-tabs/styles.css";
import {
  userVoucherList,
  userVoucherListArchive,
  userOrderList,
  customerDetail,
  profileUpdate,
  changePassword,
  checkUserDeal,
  storeCredit,
  getSiteCity,
  userCoupanList,
  getRefferals,
  delteCard,
  mailedOrderList,
  giftOrderList,
  getcharityList,
  generatedOrderList,
} from "../../../redux/actions/frontActions";
import logo from "../../../img/ddb-logo.png";

import moment from "moment";
import { Notification } from "../../../components/notifications";
import { renderAlert, clearAlert } from "../../../redux/actions/alertsActions";
import CountryStateCity from "../../../components/countryStateCity/CountryStateCity";
import auth from "../../../services/auth";
import { appConfig } from "../../../config";
import { CopyToClipboard } from "react-copy-to-clipboard";
import DatePicker from "react-date-picker";
import Dialog from "react-bootstrap-dialog";
import languageConfig from "../../../config/languageConfig";
import Cookies from "universal-cookie";
import PasswordChecklist from "react-password-checklist"

const history = createBrowserHistory();
const cookies = new Cookies();

let cart = "",
  isLoading = "false",
  load_more = "false";

function Currency(props) {
  const cur = props.default_currency == "EUR" ? "€" : "$";
  return (
    <span className={props.className}>
      {props.default_lang == "en" ? cur : ""}
      {props.amount}
      {props.default_lang == "fr" ? cur : ""}
    </span>
  );
}
class MyAccount extends Component {
  static contextTypes = {
    router: PropTypes.object,
  };
  constructor(props, context) {
    super(props, context);

    this.state = {
      headers: [
        { name: "Vouchers", tablink: "vouchers", isActive: true },
        { name: "Order History", tablink: "order-history", isActive: false },
      ],
      show: false,
      page: "",
      cityID: "",
      old_password: "",
      password: "",
      cpassword: "",
      totalRecords: 0,
      ctotalRecords: 0,
      totalRecordsArchive: 0,
      currentPage: 1,
      ccurrentPage: 1,
      currentPageArchive: 1,
      limit: 25,
      currentOrderPage: "1",
      referral: "",
      copied: false,
      dealresponse: "",
      refferralresponse: "",
      userTypeID: "",
      disabled1: false,
      disabled2: false,
      referralStatus: false,
      hover: false,
      charity: "",
      charity_id: "",
      disabled: false,
      cityList: [],
      charity_name: "",
      refferals: "",
      card_data: "",
      check_card: "",
      show: false,
      multi_lang: "no",
      lang: "",
      default_lang:
        "(cookies.get('default_lang') ? cookies.get('default_lang') : 'en')",
      currency: "",
      assigned_city_ids: "",
      refferalhtml: "",
      load_archive_list: false,
      loadmorebutton: false,
      skuCodeIcon: "glyphicon glyphicon-sort-by-attributes-alt",
      merchantNameIconCur: "glyphicon glyphicon-sort-by-attributes-alt",
      redeemDateIconCur: "glyphicon glyphicon-sort-by-attributes-alt",
      statusIconCur: "glyphicon glyphicon-sort-by-attributes-alt",
       searchvoucher: "",
       searcharchivevoucher:'',
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);

    this.handlePageChange = this.handlePageChange.bind(this);

    this.handleDismiss = this.handleDismiss.bind(this);
    this.handleShow = this.handleShow.bind(this);
    this.Clear = this.Clear.bind(this);

    this.handlePasswordSubmit = this.handlePasswordSubmit.bind(this);

    this.handleVoucherPageChange = this.handleVoucherPageChange.bind(this);
    this.handleVoucherArchivePageChange =
      this.handleVoucherArchivePageChange.bind(this);
    this.handleOrderPageChange = this.handleOrderPageChange.bind(this);
    this.deleteCardDetail = this.deleteCardDetail.bind(this);
    this.handleShow = this.handleShow.bind(this);
       this.handleSearch = this.handleSearch.bind(this);
       this.handleArchiveSearch=this.handleArchiveSearch.bind(this);
       this.handleOrderSearch=this.handleOrderSearch.bind(this);
 }

   handleSearch(e) {
  this.setState({ [e.target.name]: e.target.value });
 
    if (e.target.value.length > 1  ) {
      if(e.target.name === 'searchvoucher')
      {
     const postData = {
        page: 1,
        limit: this.state.limit,
        lang: this.state.default_lang,
        searchvoucher: e.target.value};
        this.props.userVoucherList(postData);
  }

  if(e.target.name === 'coupon')
  {
      this.props.userCoupanList({
        page: 1,
        limit: this.state.limit,
        lang: this.state.default_lang,
        voucherType: "direct",
        searchvoucher: e.target.value,
      });
  }
  if(e.target.name === 'mailed')
  {
      this.props.mailedOrderList({
        page: 1,
        limit: this.state.limit,
        lang: this.state.default_lang,
        voucherType: "non_shipable",
        searchvoucher: e.target.value,
      });
  }

  if(e.target.name === 'giftcards')
  {
     this.props.giftOrderList({
        page: 1,
        limit: this.state.limit,
        lang: this.state.default_lang,
        voucherType: "gift_card",
         searchvoucher: e.target.value,
      });
  }

  if(e.target.name === 'generate_voucher')
  {
     this.props.generatedOrderList({
        page: 1,
        limit: this.state.limit,
        lang: this.state.default_lang,
        voucherType: "generate_voucher",
        searchvoucher: e.target.value,
      });
  }
}
  else
    {    if(e.target.name === 'searchvoucher')
      {
       const postData = {
        page: this.state.currentPage,
        limit: this.state.limit,
        lang: this.state.default_lang,
        searchvoucher: e.target.value};
        this.props.userVoucherList(postData);
      }
       if(e.target.name === 'coupon')
  {
      this.props.userCoupanList({
        page: this.state.ccurrentPage,
        limit: this.state.limit,
        lang: this.state.default_lang,
        voucherType: "direct",
        searchvoucher: e.target.value,
      });
  }
  if(e.target.name === 'mailed')
  {
      this.props.mailedOrderList({
        page: this.state.ccurrentPage,
        limit: this.state.limit,
        lang: this.state.default_lang,
        voucherType: "non_shipable",
        searchvoucher: e.target.value,
      });
  }
   if(e.target.name === 'giftcards')
  {
     this.props.giftOrderList({
        page: this.state.ccurrentPage,
        limit: this.state.limit,
        lang: this.state.default_lang,
        voucherType: "gift_card",
        searchvoucher: e.target.value,
      });
  }

   if(e.target.name === 'generate_voucher')
  {
     this.props.generatedOrderList({
        page:  this.state.ccurrentPage,
        limit: this.state.limit,
        lang: this.state.default_lang,
        voucherType: "generate_voucher",
        searchvoucher: e.target.value,
      });
  }
     
}
}

  handleArchiveSearch(e) {
     this.setState({ [e.target.name]: e.target.value });

    if (e.target.value.length > 1  ) {
     const postData = {
        page: 1,
        limit: this.state.limit,
        lang: this.state.default_lang,
        searcharchivevoucher: e.target.value};
        this.props.userVoucherListArchive(postData);
}

    else
    {
       const postData = {
        page: this.state.ccurrentPage,
        limit: this.state.limit,
        lang: this.state.default_lang,
        searcharchivevoucher: e.target.value};
        this.props.userVoucherListArchive(postData);
     }
    }
           
handleOrderSearch(e)
{
   this.setState({ [e.target.name]: e.target.value });

    if (e.target.value.length > 1  ) {
    
       this.props.userOrderList({
      page: 1,
      limit: this.state.limit,
      lang: this.state.default_lang,
      userID: localStorage.getItem("user_sec_id"),
      search: e.target.value,
    });
}

    else
    {
   this.props.userOrderList({
      page: this.state.ccurrentPage,
      limit: this.state.limit,
      lang: this.state.default_lang,
      userID: localStorage.getItem("user_sec_id"),
      search: e.target.value,
    });

}
 
 }
  handleShow() {
    this.setState({ show: true });
  }
  sorting(orderby, direction, voucherType) {
    if (orderby === "redeem_date" && direction === "DESC") {
      this.setState({ redeemdatesortOrder: "ASC" });
      this.setState({
        redeemDateIconCur: "glyphicon glyphicon-sort-by-attributes",
      });
    } else {
      this.setState({ redeemdatesortOrder: "DESC" });
      this.setState({
        redeemDateIconCur: "glyphicon glyphicon-sort-by-attributes-alt",
      });
    }

    if (orderby === "expiration" && direction === "DESC") {
      this.setState({ merchantNamesortOrder: "ASC" });
      this.setState({
        merchantNameIconCur: "glyphicon glyphicon-sort-by-attributes",
      });
    } else {
      this.setState({ merchantNamesortOrder: "DESC" });
      this.setState({
        merchantNameIconCur: "glyphicon glyphicon-sort-by-attributes-alt",
      });
    }

    if (orderby === "status" && direction === "DESC") {
      this.setState({ statussortOrder: "ASC" });
      this.setState({
        statusIconCur: "glyphicon glyphicon-sort-by-attributes",
      });
    } else {
      this.setState({ statussortOrder: "DESC" });
      this.setState({
        statusIconCur: "glyphicon glyphicon-sort-by-attributes-alt",
      });
    }

    this.setState({ orderby: orderby });
    this.setState({ direction: direction });
    this.setState({ voucherType: voucherType });
    isLoading = "true";
    if (voucherType === "") {
      const postData = {
        page: this.state.currentPage,
        limit: this.state.limit,
        lang: this.state.default_lang,
        search: this.state.search,
        orderBy: orderby,
        direction: direction,
        voucherType: voucherType,
      };
      this.props.userVoucherList(postData);
    }
    if (voucherType === "direct") {
      this.props.userCoupanList({
        page: this.state.ccurrentPage,
        limit: this.state.limit,
        lang: this.state.default_lang,
        search: this.state.search,
        orderBy: orderby,
        direction: direction,
        voucherType: voucherType,
      });
      // isLoading = "false";
    }
    if (voucherType === "gift_card") {
      this.props.giftOrderList({
        page: this.state.ccurrentPage,
        limit: this.state.limit,
        lang: this.state.default_lang,
        search: this.state.search,
        orderBy: orderby,
        direction: direction,
        voucherType: voucherType,
      });
      // isLoading = "false";
    }
    if (voucherType === "non_shipable") {
      this.props.mailedOrderList({
        page: this.state.ccurrentPage,
        limit: this.state.limit,
        lang: this.state.default_lang,
        search: this.state.search,
        orderBy: orderby,
        direction: direction,
        voucherType: voucherType,
      });
      // isLoading = "false";
    }
    if (voucherType === "generate_voucher") {
      this.props.generatedOrderList({
        page: this.state.ccurrentPage,
        limit: this.state.limit,
        lang: this.state.default_lang,
        search: this.state.search,
        orderBy: orderby,
        direction: direction,
        voucherType: voucherType,
      });
      // isLoading = "false";
    }
  }

  deleteCardDetail = (cardNumber) => {
    this.dialog.show({
      body: "Are you sure you want to delete this?",
      actions: [
        Dialog.CancelAction(),
        Dialog.OKAction(() => {
          this.confirmDelete(cardNumber);
          this.handleShow();
        }),
      ],
    });
  };
  showloadArchive() {
    load_more = "show";
  }
  confirmDelete(cardNumber) {
    let constData = {
      cardNumber: cardNumber,
      userID: localStorage.getItem("user_id"),
    };
    this.props.delteCard(constData);
  }

  onChangeStartDate = (selectedDate) => {
   
    if (selectedDate instanceof Date && !isNaN(selectedDate)) {
         this.setState({
           dob: selectedDate,
           dobError: false // Reset error state if a valid date is selected
         });
       } 
       else if(selectedDate  === null)
       {
        this.setState({
          dob: '',
          dobError: false // Reset error state if a valid date is selected
        });
       }
       else {
        this.setState({
       dobError: true // Set error state to indicate invalid date
           
         });
    
       }
     };

  hoverOn = (e) => {
    this.setState({
      hover: true,
      hoverID: e.target.attributes.getNamedItem("data-id").value,
    });
  };

  hoverOff = (e) => {
    this.setState({
      hover: false,
      hoverID: e.target.attributes.getNamedItem("data-id").value,
    });
  };

  handleChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });

    if (`${e.target.name}Error` !== "") {
      this.setState({ [`${e.target.name}Error`]: "" });
    }
    this.setState({ disabled1: false });
    this.setState({ disabled2: false });
  };

  setDefaultLanguage = (lang) => {
    let siteData = JSON.parse(localStorage.getItem("siteDDBStatus"));
    siteData.default_lang = lang;
    localStorage.setItem("siteDDBStatus", JSON.stringify(siteData));
    this.setState({
      default_lang: lang,
    });

    let d = new Date();
    d.setTime(d.getTime() + 480 * 60 * 1000);
    cookies.set("default_lang", lang, { path: "/", expires: d });

    this.props.setLanguage(lang);
    this.props.getSiteStatus(lang);
    this.props.getMenuList({
      page: 1,
      lang: lang,
      cityID: siteData.default_city,
    });
    if (cookies.get("token")) {
      //this.props.getQuantityCart({'userKey':cookies.get('token'), lang: lang});
      this.props.getCartDetail({ userKey: cookies.get("token"), lang: lang });
    }
  };

  componentDidMount() {
    let userID = localStorage.getItem("user_id")
      ? localStorage.getItem("user_id")
      : "";
    let siteData = JSON.parse(localStorage.getItem("siteDDBStatus"));

    if (siteData) {
      if (siteData.default_city || siteData.multi_lang == "yes") {
        this.setState({
          multi_lang: siteData.multi_lang,
          lang: siteData.lang,
          default_lang: cookies.get("default_lang")
            ? cookies.get("default_lang")
            : siteData.default_lang,
        });
      }
    }

    this.setState({
      user_id: userID,
    });
    if (userID) {
      //this.props.userVoucherList({voucherType: 'gift_card'});
    }
  }

  handlePageChange = (page) => {
    this.setState({
      currentPage: page,
      ccurrentPage: page,
      currentPageArchive: page,
    });
    let siteData = JSON.parse(localStorage.getItem("siteDDBStatus"));

    if (siteData) {
      if (siteData.default_city || siteData.multi_lang == "yes") {
        this.setState({
          multi_lang: siteData.multi_lang,
          lang: siteData.lang,
          default_lang: siteData.default_lang,
        });
      }
    }
    this.props.userVoucherList({
      page: this.state.currentPage,
      limit: this.state.limit,
      lang: siteData.default_lang,
      search: this.state.search,
      orderBy: this.state.orderby,
      direction: this.state.direction,
    });
    // this.props.userVoucherListArchive({
    //   page: this.state.currentPageArchive,
    //   limit: this.state.limit,
    //   lang: siteData.default_lang,
    // });
  };

  handleCoupanPageChange = (page) => {
    this.setState({
      ccurrentPage: page,
    });
    const postData = {
      page: page,
      limit: this.state.limit,
      voucherType: "direct",
      lang: this.state.default_lang,
    };
    this.props.userCoupanList(postData);
  };

  handleVoucherPageChange = (page) => {
    this.setState({
      currentPage: page,
    });
    const postData = {
      page: page,
      limit: this.state.limit,
      lang: this.state.default_lang,
      search: this.state.search,
      orderBy: this.state.orderby,
      direction: this.state.direction,
    };
    this.props.userVoucherList(postData);
    //    console.log(this.props.voucherList.loadmore);
    // const postDataArchive = {
    //   page: 1,
    //   limit: this.state.limit,
    //   lang: this.state.default_lang,
    // };
    // this.props.userVoucherListArchive(postDataArchive);
  };

  handleVoucherArchivePageChange = (page) => {
     this.setState({
      ccurrentPage: page,
    });
    const postDataArchive = {
      page: page,
      limit: this.state.limit,
      lang: this.state.default_lang,
    };
    this.props.userVoucherListArchive(postDataArchive);
  };

  handleMailedPageChange = (page) => {
    this.setState({
      ccurrentPage: page,
    });
    const postData = {
      page: page,
      limit: this.state.limit,
      voucherType: "non_shipable",
      lang: this.state.default_lang,
      search: this.state.search,
      orderBy: this.state.orderby,
      direction: this.state.direction,
    };
    this.props.mailedOrderList(postData);
  };

  handleGiftPageChange = (page) => {
    this.setState({
      ccurrentPage: page,
    });
    const postData = {
      page: page,
      limit: this.state.limit,
      voucherType: "gift_card",
      lang: this.state.default_lang,
      search: this.state.search,
      orderBy: this.state.orderby,
      direction: this.state.direction,
    };
    this.props.giftOrderList(postData);
  };

  handleGeneratedPageChange = (page) => {
    this.setState({
      ccurrentPage: page,
    });
    const postData = {
      page: page,
      limit: this.state.limit,
      voucherType: "generate_voucher",
      lang: this.state.default_lang,
      search: this.state.search,
      orderBy: this.state.orderby,
      direction: this.state.direction,
    };
    this.props.generatedOrderList(postData);
  };

  handleOrderPageChange = (page) => {
    this.setState({
      ccurrentPage: page,
    });
    this.props.userOrderList({
      page: page,
      limit: this.state.limit,
      lang: this.state.default_lang,
      userID: localStorage.getItem("user_sec_id"),
    });
  };

  handleDismiss() {
    this.setState({ show: false });
  }

  handleShow() {
    this.setState({ show: true });
  }

  Clear() {}

  componentWillMount() {
    let siteData = JSON.parse(localStorage.getItem("siteDDBStatus"));
      if (siteData) {
      if (siteData.default_city || siteData.multi_lang == "yes") {
        this.setState({
          multi_lang: siteData.multi_lang,
          lang: siteData.lang,
          default_lang: siteData.default_lang,
        });
      }
      if (siteData.currency) {
        this.setState({
          currency: siteData.currency,
        });
      }
      this.setState({ assigned_city_ids: siteData.default_city });
    }

    this.props.clearAlert();
    this.handleDismiss();
    this.props.checkUserDeal();
    this.props.storeCredit();
    this.handlePageChange(1);
    this.props.getSiteCity();
     this.props.partnerPermission('registration-form/fields');
    this.props.getcharityList({
      assigned_city_ids: siteData.default_city ? siteData.default_city : "",
    });

    const userinfo = auth.getUserInfo();
    let userID =
      userinfo && userinfo.user_sec_id !== "" ? userinfo.user_sec_id : "";
    let url = appConfig.site.siteurl;
    let referral = url + "/referral/" + userID;
    this.setState({ referral: referral });

    if (siteData) {
      this.setState({
        referralStatus: siteData.referral_setting == "disable" ? false : true,
        check_card: siteData.check_card,
        charityOption: siteData.charity,
      });
    }

    if (this.props.themeData) {
      if (this.props.themeData.button) {
        this.setState({
          button_color: this.props.themeData.button.button_color,
          mouseover_color: this.props.themeData.button.mouseover_color,
        });
      }
    }

    if (this.props.themeData) {
      if (this.props.themeData.button) {
        this.setState({
          button_color: this.props.themeData.button.button_color,
          mouseover_color: this.props.themeData.button.mouseover_color,
        });
      }
    }
  }

  componentWillReceiveProps(nextProps) {
 if (
      parseInt(nextProps.voucherList.total) ===
      parseInt(nextProps.voucherList.to)
    ) {
      
    } else if (parseInt(nextProps.voucherList.total) === 0) {
      
      // this.props.userVoucherListArchive({
      //   page: 1,
      //   limit: this.state.limit,
      //   lang: this.state.default_lang,
      // });
    } else {
      this.setState({
        loadmorebutton: false,
        load_archive_list: false,
      });
    }

  
    if (nextProps.language) {
      if (this.state.default_lang !== nextProps.language) {
        this.setState({ default_lang: nextProps.language, key: 1 });
        this.props.userVoucherList({
          page: this.state.currentPage,
          limit: this.state.limit,
          lang: nextProps.language,
        });
        // this.props.userVoucherListArchive({
        //   page: this.state.currentPageArchive,
        //   limit: this.state.limit,
        //   lang: nextProps.language,
        // });
      }
    }

    if (this.props.card != nextProps.card) {
      if (nextProps.card) {
        this.props.clearAlert();
        this.handleShow();
        this.props.renderAlert("success", nextProps.card.message);
        isLoading = "true";
        this.props.storeCredit();
      }
    }

    if (nextProps.themeData) {
      if (nextProps.themeData.button) {
        this.setState({
          button_color: nextProps.themeData.button.button_color,
          mouseover_color: nextProps.themeData.button.mouseover_color,
        });
      }
    }

    if (this.props.refferals !== nextProps.refferals) {
      if (nextProps.refferals) {
        this.setState({
          refferals: nextProps.refferals.data,
          refferalhtml: nextProps.refferals.referral_content,
        });
        isLoading = "false";
      }
    }
   
 if(this.props.permission !== nextProps.permission) {

      if(nextProps.permission) {
        if(nextProps.permission.data) {
      console.log(nextProps.permission.data.enabled.gender);
          this.setState({
            enabled: nextProps.permission.data.enabled.gender,
            required: nextProps.permission.data.required
          });
        }
        isLoading = 'false';
      }
    }
    if (this.props.voucherList !== nextProps.voucherList) {
      if (nextProps.voucherList) {
        const setPageCount =
          nextProps.voucherList.total / nextProps.voucherList.per_page;
        this.setState({
          voucherList: nextProps.voucherList.data,
          totalRecords: nextProps.voucherList.total,
          perPage: nextProps.voucherList.per_page,
          pageCount: setPageCount,
        });
        isLoading = "false";
      }
    }

    if (this.props.voucherListArchive !== nextProps.voucherListArchive) {
      if (nextProps.voucherListArchive) {
        const setPageCount =
          nextProps.voucherListArchive.total /
          nextProps.voucherListArchive.per_page;
        this.setState({
          voucherListArchive: nextProps.voucherListArchive.data,
          totalRecordsArchive: nextProps.voucherListArchive.total,
          perPageArchive: nextProps.voucherListArchive.per_page,
          pageCount: setPageCount,
        });
        isLoading = "false";
      }
    }

    if (this.props.couponList !== nextProps.couponList) {
      if (nextProps.couponList) {
        const csetPageCount =
          nextProps.couponList.total / nextProps.couponList.per_page;
        this.setState({
          couponList: nextProps.couponList.data,
          ctotalRecords: nextProps.couponList.total,
          cperPage: nextProps.couponList.per_page,
          cpageCount: csetPageCount,
        });
        isLoading = "false";
      }
    }

    if (this.props.orderRedeem != nextProps.orderRedeem) {
      if (nextProps.orderRedeem) {
        this.setState({ showAlert: true });
        this.handleShow();
        this.props.renderAlert("success", nextProps.orderRedeem.message);
        this.props.userVoucherList({
          page: this.state.currentPage,
          limit: this.state.limit,
          lang: this.state.default_lang,
        });
        // this.props.userVoucherListArchive({
        //   page: this.state.currentPageArchive,
        //   limit: this.state.limit,
        //   lang: this.state.default_lang,
        // });
        window.scrollTo(0, 0);
      }
    }

    // if (this.props.orderList !== nextProps.orderList) {
    //   if (nextProps.orderList) {
    //     const setOrderPageCount =
    //       nextProps.orderList.total / nextProps.orderList.per_page;

    //     this.setState({
    //       orderList: nextProps.orderList.data,
    //       totalOrderRecords: nextProps.orderList.total,
    //       perOrderPage: nextProps.orderList.per_page,
    //       pageOrderCount: setOrderPageCount
    //     });
    //     isLoading = "false";
    //   }
    // }

    if (this.props.mailedList !== nextProps.mailedList) {
      if (nextProps.mailedList) {
        const mailedsetPageCount =
          nextProps.mailedList.total / nextProps.mailedList.per_page;

        this.setState({
          mailedList: nextProps.mailedList.data,
          mailedtotalRecords: nextProps.mailedList.total,
          mailedperPage: nextProps.mailedList.per_page,
          mailedpageCount: mailedsetPageCount,
        });
        isLoading = "false";
      }
    }

    if (this.props.giftList !== nextProps.giftList) {
      if (nextProps.giftList) {
        const giftsetPageCount =
          nextProps.giftList.total / nextProps.giftList.per_page;

        this.setState({
          giftList: nextProps.giftList.data,
          gifttotalRecords: nextProps.giftList.total,
          giftperPage: nextProps.giftList.per_page,
          giftpageCount: giftsetPageCount,
        });
        isLoading = "false";
      }
    }

    if (this.props.generatedList !== nextProps.generatedList) {
      if (nextProps.generatedList) {
        const generatedsetPageCount =
          nextProps.generatedList.total / nextProps.generatedList.per_page;

        this.setState({
          generatedList: nextProps.generatedList.data,
          generatedtotalRecords: nextProps.generatedList.total,
          generatedperPage: nextProps.generatedList.per_page,
          generatedpageCount: generatedsetPageCount,
        });
        isLoading = "false";
      }
    }

    if (this.props.orderList !== nextProps.orderList) {
      if (nextProps.orderList) {
        const setOrderPageCount =
          nextProps.orderList.total / nextProps.orderList.per_page;

        this.setState({
          orderList: nextProps.orderList.data,
          totalOrderRecords: nextProps.orderList.total,
          perOrderPage: nextProps.orderList.per_page,
          pageOrderCount: setOrderPageCount,
        });
        isLoading = "false";
      }
    }

    if (this.props.custDetail !== nextProps.custDetail) {
      if (nextProps.custDetail) {
        const charityID = nextProps.custDetail.charityID;
        let charity_name = "";
        let charity = "";
        if (charityID) {
          charity = this.state.charity.find(
            (charity) => charity.charity_id === charityID
          );
          if (charity) {
            charity_name = charity.charity_name;
          }
        }

        this.setState({
          firstName: nextProps.custDetail.firstName,
          lastName: nextProps.custDetail.lastName,
          email: nextProps.custDetail.email,
          phone: nextProps.custDetail.phone,
          gender: nextProps.custDetail.gender,
          dob: nextProps.custDetail.dob
            ? new Date(moment(nextProps.custDetail.dob).format("YYYY/MM/DD"))
            : "",
          address1: nextProps.custDetail.address1,
          address2: nextProps.custDetail.address2,
          zipcode: nextProps.custDetail.zipcode,
          country: nextProps.custDetail.country,
          state: nextProps.custDetail.state,
          stateAbbr: nextProps.custDetail.stateAbbr,
          addCity: nextProps.custDetail.addCity,
          city: nextProps.custDetail.city,
          cityID: nextProps.custDetail.cityID,
          user_id: nextProps.custDetail.user_id,
          userTypeID: nextProps.custDetail.userTypeID,
          charity_id: nextProps.custDetail.charityID,
          charity_name: charity_name,
        });
        isLoading = "false";
      }
    }

    if (this.props.getCharity !== nextProps.getCharity) {
      if (nextProps.getCharity) {
        const charities = nextProps.getCharity;
        this.setState({ charity: nextProps.getCharity });
      }
    }

    if (this.props.profileStatus != nextProps.profileStatus) {
      if (nextProps.profileStatus) {
        this.setState({ disabled1: false });
        this.props.clearAlert();
        this.handleShow();
        this.props.renderAlert("success", nextProps.profileStatus.message);
        isLoading = "false";
        this.Clear();
        let siteData = JSON.parse(localStorage.getItem("siteDDBStatus"));
        if (siteData) {
          this.setState({
            siteName: siteData.siteName,
            charityOption: siteData.charity,
          });
        }
      }
    }

    if (this.props.passwordStatus != nextProps.passwordStatus) {
      if (nextProps.passwordStatus) {
        this.setState({ disabled2: false });
        this.props.clearAlert();
        this.handleShow();
        this.props.renderAlert("success", nextProps.passwordStatus.message);
        isLoading = "false";
        this.Clear();
      }
    }

    if (this.props.userdealResponse != nextProps.userdealResponse) {
      if (nextProps.userdealResponse) {
        this.setState({ dealresponse: nextProps.userdealResponse.response });
        this.setState({
          refferralresponse: nextProps.userdealResponse.refferral,
        });
        if (nextProps.userdealResponse.response == "success") {
          this.props.storeCredit();
        }
      }
    }

    if (this.props.creditAmount != nextProps.creditAmount) {
      if (nextProps.creditAmount) {
        isLoading = "false";
        this.setState({
          creditAmount: nextProps.creditAmount.data,
          card_data: nextProps.creditAmount.card_data,
        });
      }
    }

    if (this.props.error != nextProps.error) {
      if (nextProps.error) {
        this.props.clearAlert();
        this.handleShow();
        this.props.renderAlert("warning", nextProps.error);
        isLoading = "false";
        this.setState({ disabled1: false });
        this.setState({ disabled2: false });
        let siteData = JSON.parse(localStorage.getItem("siteDDBStatus"));
        if (siteData) {
          this.setState({
            siteName: siteData.siteName,
            charityOption: siteData.charity,
          });
        }
        if (
          nextProps.error == "Unauthenticated." ||
          nextProps.error == "Unauthenticated"
        ) {
          auth.clearAllAppStorage();
          localStorage.removeItem("user");
          localStorage.removeItem("user_id");
          localStorage.removeItem("userTypeName");
          localStorage.removeItem("userTypeID");
          localStorage.removeItem("siteID");
          localStorage.removeItem("user_sec_id");
          this.context.router.history.push("/login");
        }
      }
    }

    if (nextProps.message) {
      this.handleShow();
      this.setState({
        alertMessage: nextProps.message,
        msgType: nextProps.alertType,
      });
    }

    if (this.props.cityList != nextProps.cityList) {
      if (nextProps.cityList) {
        this.setState({ cityList: nextProps.cityList.data });
      }
    }
  }

  componentWillUpdate(nextProps, nextState) {}

  validate = () => {
    let isError = false;
    const errors = {};

    if (!this.state.firstName) {
      isError = true;
      this.setState({ firstNameError: "red" });
    }

    if (!this.state.lastName) {
      isError = true;
      this.setState({ lastNameError: "red" });
    }

    if (!this.state.email) {
      isError = true;
      this.setState({ emailError: "red" });
    } else if (this.state.email) {
      if (this.getValidationEmailState()) {
        isError = true;
        this.setState({ emailError: "red" });
      }
    }

    // if (!this.state.address1) {
    //   isError = true;
    //   this.setState({ address1Error: "red" });
    // }

    if (!this.state.country) {
      isError = true;
      this.setState({ countryError: "red" });
    }

    if (!this.state.state) {
      isError = true;
      this.setState({ stateError: "red" });
    }

    if (!this.state.addCity) {
      isError = true;
      this.setState({ addCityError: "red" });
    }

    if (!this.state.cityID) {
      isError = true;
      this.setState({ cityIDError: "red" });
    }

    return isError;
  };

  passwordValidate = () => {
    let isError = false;
    const errors = {};

    if (!this.state.old_password) {
      isError = true;
      this.setState({ old_passwordError: "red" });
    }

    if (!this.state.password) {
      isError = true;
      this.setState({ passwordError: "red" });
    }

    if (this.state.password !== this.state.cpassword) {
      isError = true;
      this.setState({ cpasswordError: "red" });
    }

    return isError;
  };

  handlePasswordSubmit = (e) => {
    e.preventDefault();
    this.setState({ disabled: true });
    const err = this.passwordValidate();
    if (!err) {
      const formData = {
        userID: localStorage.getItem("user_id"),
        old_password: this.state.old_password,
        password: this.state.password,
      };
      this.props.changePassword(formData);
    }
  };

  handleSubmit = (e) => {
    e.preventDefault();
    this.setState({ disabled: true });
    const err = this.validate();
    if (!err) {
      isLoading = "true";
      let formData = {
        id: this.state.user_id,
        firstName: this.state.firstName,
        lastName: this.state.lastName,
        email: this.state.email,
        phone: this.state.phone,
        gender: this.state.gender,
        dob: moment(this.state.dob).format("YYYY/MM/DD"),
        address1: this.state.address1,
        address2: this.state.address2,
        country: this.state.country,
        state: this.state.state,
        addCity: this.state.addCity,
        city: this.state.city,
        cityID: this.state.cityID,
        stateAbbr: this.state.stateAbbr,
        zipcode: this.state.zipcode,
        status: "Active",
        charity_id: this.state.charity_id,
        userTypeID: this.state.userTypeID,
      };

      this.props.profileUpdate(formData);
    }
  };

  handleClipboard(e) {
    e.preventDefault();
  }

  onChange({ target: { value } }) {
    this.setState({ value, copu: false });
  }

  onCopy = (e) => {
    this.setState({
      copied: true,
      alertMessage: "Copied to clipboard!",
      msgType: "success",
      show: true,
    });
    window.getSelection().toString();
  };

  handleTabs = (key) => {
    this.setState({ key: key });
    if (key === 1) {

      isLoading = "true";
      this.props.userVoucherList({
        page: 1,
        limit: this.state.limit,
        lang: this.state.default_lang,
      });
      // this.props.userVoucherListArchive({
      //   page: this.state.currentPageArchive,
      //   limit: this.state.limit,
      //   lang: this.state.default_lang,
      // });
    } 
 else if (key === 11) {
      isLoading = "true";
      
      this.props.userVoucherListArchive({
        page: 1,
        limit: this.state.limit,
        lang: this.state.default_lang,
      });
        this.setState({ currentPage: 1 });
    }

    else if (key === 4) {
      isLoading = "true";
      this.props.customerDetail(localStorage.getItem("user_sec_id"));
    } else if (key === 2) {
      isLoading = "true";
      this.props.userCoupanList({
        page: 1,
        limit: this.state.limit,
        lang: this.state.default_lang,
        voucherType: "direct",
      });
    this.setState({ ccurrentPage: 1 });
    } else if (key === 6) {
      isLoading = "true";
      this.props.getRefferals({ lang: this.state.default_lang });
    } else if (key === 7) {
      isLoading = "true";
      this.props.userOrderList({
        page: this.state.currentOrderPage,
        limit: this.state.limit,
        lang: this.state.default_lang,
        userID: localStorage.getItem("user_sec_id"),
      });
    } else if (key === 8) {
      isLoading = "true";
      this.props.mailedOrderList({
        page: 1,
        limit: this.state.limit,
        lang: this.state.default_lang,
        voucherType: "non_shipable",
      });
      this.setState({ ccurrentPage: 1 });
    } else if (key === 9) {
      isLoading = "true";
      this.props.giftOrderList({
        page: 1,
        limit: this.state.limit,
        lang: this.state.default_lang,
        voucherType: "gift_card",
      });
     this.setState({ ccurrentPage: 1 });
    } else if (key === 10) {
      isLoading = "true";
      this.props.generatedOrderList({
        page: 1,
        limit: this.state.limit,
        lang: this.state.default_lang,
        voucherType: "generate_voucher",
      });
    }
    this.setState({ ccurrentPage: 1 });
  };

  onChangeCharity = (e) => {
    this.setState({ charity_name: e.target.value });
    this.props.getcharityList({
      limit: 10,
      search: e.target.value,
      assigned_city_ids: this.state.assigned_city_ids,
    });
  };

  onVoucherRedeem = (voucherNumber) => {
    this.props.voucherStatus({
      voucherNumber: voucherNumber,
      lang: this.state.default_lang,
      redeemedBy: "Customer",
    });
  };

  //test
  printVoucher = (list) => {
    const redemptionWaitPeriod = list.redemptionWaitPeriod;
    const todayDateTime = moment().format("YYYY/MM/DD HH:mm:ss");
    const expiryDateTime = moment(list.expiryDateTime)
      .add(redemptionWaitPeriod, "hours")
      .format("YYYY/MM/DD HH:mm:ss");
    if (
      redemptionWaitPeriod != "" &&
      redemptionWaitPeriod != null &&
      expiryDateTime > todayDateTime
    ) {
      this.setState({
        alertMessage:
          "This voucher would not print until the offer ended date " +
          expiryDateTime,
        msgType: "warning",
        show: true,
      });
    } else {
      this.context.router.history.push(`/voucher/${list.voucherID}`);
    }
  };
  printarchiveVoucher = (list) => {
    const redemptionWaitPeriod = list.redemptionWaitPeriod;
    const todayDateTime = moment().format("YYYY/MM/DD HH:mm:ss");
    const expiryDateTime = moment(list.expiryDateTime)
      .add(redemptionWaitPeriod, "hours")
      .format("YYYY/MM/DD HH:mm:ss");
    if (
      redemptionWaitPeriod != "" &&
      redemptionWaitPeriod != null &&
      expiryDateTime > todayDateTime
    ) {
      this.setState({
        alertMessage:
          "This voucher would not print until the offer ended date " +
          expiryDateTime,
        msgType: "warning",
        show: true,
      });
    } else {
      this.context.router.history.push(`/voucherarchive/${list.voucherID}`);
    }
  };

  loadArchive = () => {
    this.setState({ load_archive_list: true });
  };

  getValidationEmailState() {
    if (this.state.email) {
      const length = this.state.email.length;
      if (length !== 0) {
        let emailpattern = new RegExp(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i);
        if (!emailpattern.test(this.state.email)) {
          return "error";
        }
      }
    }

    return null;
  }

  render() {
    let v = 1,
      m = 1,
      g = 1,
      gn = 1,
      o = 1,
      vArchive = 1,
      c = 1;
    var final_number = 0;
    const {
      currentPage,
      currentPageArchive,
      totalRecords,
      totalRecordsArchive,
      perPage,
      perPageArchive,
      pageCount,
      ccurrentPage,
      ctotalRecords,
      cperPage,
      cpageCount,
      mailedtotalRecords,
      mailedperPage,
      mailedpageCount,
      gifttotalRecords,
      giftperPage,
      giftpageCount,
      generatedtotalRecords,
      generatedperPage,
      currentOrderPage,
      totalOrderRecords,
      perOrderPage,
      pageOrderCount,
    } = this.state;

    //console.log(totalRecords);
    //console.log(perPage);
    //console.log("currentpage",currentPage);
    //console.log(pageCount);

    // if (pageCount == Math.floor(pageCount)) {
    //   //integer
    //   final_number = pageCount;
    // } else {
    //   //decimal
    //   final_number = parseInt(pageCount) + 1;
    // }

    // //console.log(final_number);

    // if (currentPage == final_number) {
    //   //show load more button
    //   console.log("show");
    //   load_more = "true";
    // } else {
    //   //hide load more button
    //   console.log("hide");
    //   load_more = "false";
    // }

    return (
      <div>
        {isLoading == "true" ? (
          <div className="loader">
            <p className="loading-message">
              <i>Loading...</i>
            </p>
            <div className="spinner">
              <div className="dot1" />
              <div className="dot2" />
            </div>
          </div>
        ) : (
          ""
        )}
        <Dialog
          ref={(el) => {
            this.dialog = el;
          }}
        />
        <div className="container min-height">
          <header className="panel-heading">
            {languageConfig[this.state.default_lang].my_account}
            {
              <span style={{ float: "right" }}>
                {" "}
                {languageConfig[this.state.default_lang].availabe_credit} :{" "}
                <Currency
                  amount={
                    this.state.creditAmount > 0 &&
                    typeof this.state.creditAmount != "undefined"
                      ? this.state.creditAmount
                      : this.state.creditAmount
                  }
                  default_lang={this.state.default_lang}
                  className="price"
                  default_currency={this.state.currency}
                />{" "}
              </span>
            }
          </header>
          {this.state.show && this.state.alertMessage !== "" && (
            <div className="col-lg-12">
              <Alert
                bsStyle={this.state.msgType}
                onDismiss={this.handleDismiss}
              >
                <strong>{this.state.msgType}:</strong> {this.state.alertMessage}
              </Alert>
            </div>
          )}
          <div className="margin-top">
            <Tabs
              activeKey={this.state.key}
              onSelect={this.handleTabs}
              id="controlled-tab-example"
            >
              <Tab
                eventKey={1}
                title={languageConfig[this.state.default_lang].vouchers}
              >
                 <div className="col-lg-3 col-md-4 col-sm-12 pull-right">
                  <FormGroup>
                    <InputGroup>
                      <FormControl
                        type="text"
                        name="searchvoucher" onKeyUp={this.handleSearch}
                         placeholder={languageConfig[this.state.default_lang].voucherstextplace}
                      />
                      <InputGroup.Addon>
                        <Glyphicon glyph="glyphicon glyphicon-search" />
                      </InputGroup.Addon>
                    </InputGroup>
                  </FormGroup>
                </div>
                <Table striped bordered condensed hover>
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>
                        {languageConfig[this.state.default_lang].merchant_offer}
                      </th>
                      <th
                        onClick={this.sorting.bind(
                          this,
                          "expiration",
                          this.state.merchantNamesortOrder,
                          ""
                        )}
                      >
                        {languageConfig[this.state.default_lang].expiration}{" "}
                        <i className={this.state.merchantNameIconCur} />
                      </th>
                      <th
                        onClick={this.sorting.bind(
                          this,
                          "redeem_date",
                          this.state.redeemdatesortOrder,
                          ""
                        )}
                      >
                        {languageConfig[this.state.default_lang].redeem_date}{" "}
                        <i className={this.state.redeemDateIconCur} />
                      </th>
                      <th>
                        {languageConfig[this.state.default_lang].redeem_value}
                      </th>
                      <th
                        onClick={this.sorting.bind(
                          this,
                          "status",
                          this.state.statussortOrder,
                          ""
                        )}
                      >
                        {languageConfig[this.state.default_lang].status}{" "}
                        <i className={this.state.statusIconCur} />
                      </th>
                      <th>{languageConfig[this.state.default_lang].action}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {!isEmpty(this.state.voucherList) ? (
                      this.state.voucherList.map((list, index) => (
                        <tr key={Math.random()}>
                          <td>{v++}</td>
                          <td>
                            <b>{list.merchantName}</b>
                            <br />#{list.voucherNumber}
                            <br />
                            {this.state.default_lang == 'en' ? list.dealText : list.french_dealText}
                          </td>
                          <td>
                            {list.never_expires && list.never_expires == "1"
                              ? languageConfig[this.state.default_lang]
                                  .never_expires
                              : moment(list.expiryDate).format("ll")}
                          </td>
                          <td>
                            {list.redeemed_at
                              ? moment(list.redeemed_at).format("ll")
                              : languageConfig[this.state.default_lang]
                                  .not_redeemed}
                          </td>
                          <td>
                            <Currency
                              amount={list.voucherValue}
                              default_lang={this.state.default_lang}
                              className="price"
                              default_currency={this.state.currency}
                            />
                          </td>
                          <td>
                            {list.voucher_status === "Redeemed"
                              ? languageConfig[this.state.default_lang].redeemed
                              : list.voucher_status}
                          </td>
                          <td>
                            <Button onClick={() => this.printVoucher(list)}>
                              <i className="glyphicon glyphicon-print" />{" "}
                              {languageConfig[this.state.default_lang].print}
                            </Button>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="7">
                          {
                            languageConfig[this.state.default_lang]
                              .data_not_found
                          }
                        </td>
                      </tr>
                    )}
                  </tbody>
                </Table>
                <div className="text-center">
                  <Pagination
                    total={totalRecords}
                    limit={perPage}
                    pageCount={5}
                    currentPage={currentPage}
                  >
                    {({
                      pages,
                      currentPage,
                      hasNextPage,
                      hasPreviousPage,
                      previousPage,
                      nextPage,
                      totalPages,
                      getPageItemProps,
                    }) => (
                      <div className="pagination">
                        <button
                          {...getPageItemProps({
                            pageValue: 1,
                            onPageChange: this.handleVoucherPageChange,
                          })}
                        >
                          {languageConfig[this.state.default_lang].first_button}
                        </button>

                        {hasPreviousPage && (
                          <button
                            {...getPageItemProps({
                              pageValue: previousPage,
                              onPageChange: this.handleVoucherPageChange,
                            })}
                          >
                            {"<"}
                          </button>
                        )}

                        {pages.map((page) => {
                          let activePage = null;
                          if (currentPage === page) {
                            activePage = {
                              backgroundColor: "#ccc",
                              color: "#666",
                            };
                          }
                          return (
                            <button
                              key={page}
                              style={activePage}
                              {...getPageItemProps({
                                pageValue: page,
                                onPageChange: this.handleVoucherPageChange,
                              })}
                            >
                              {page}
                            </button>
                          );
                        })}

                        {hasNextPage && (
                          <button
                            {...getPageItemProps({
                              pageValue: nextPage,
                              onPageChange: this.handleVoucherPageChange,
                            })}
                          >
                            {">"}
                          </button>
                        )}

                        <button
                          {...getPageItemProps({
                            pageValue: totalPages,
                            onPageChange: this.handleVoucherPageChange,
                          })}
                        >
                          {languageConfig[this.state.default_lang].last_button}
                        </button>
                      </div>
                    )}
                  </Pagination>
                 

                  {/**start archived voucher**/}
              
                  {/**end archived voucher**/}
                </div>
              </Tab>

              <Tab
                eventKey={11}
                title={languageConfig[this.state.default_lang].archivevouchers}
              >

                <div className="col-lg-3 col-md-4 col-sm-12 pull-right">
                  <FormGroup>
                    <InputGroup>
                      <FormControl
                        type="text"
                        name="searcharchivevoucher"
                        onKeyUp={this.handleArchiveSearch}
                       
                      />
                      <InputGroup.Addon>
                        <Glyphicon glyph="glyphicon glyphicon-search" />
                      </InputGroup.Addon>
                    </InputGroup>
                  </FormGroup>
                </div>
                <Table striped bordered condensed hover>
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>
                        {languageConfig[this.state.default_lang].merchant_offer}
                      </th>
                      <th
                        onClick={this.sorting.bind(
                          this,
                          "expiration",
                          this.state.merchantNamesortOrder,
                          ""
                        )}
                      >
                        {languageConfig[this.state.default_lang].expiration}{" "}
                        <i className={this.state.merchantNameIconCur} />
                      </th>
                      <th
                        onClick={this.sorting.bind(
                          this,
                          "redeem_date",
                          this.state.redeemdatesortOrder,
                          ""
                        )}
                      >
                        {languageConfig[this.state.default_lang].redeem_date}{" "}
                        <i className={this.state.redeemDateIconCur} />
                      </th>
                      <th>
                        {languageConfig[this.state.default_lang].redeem_value}
                      </th>
                      <th
                        onClick={this.sorting.bind(
                          this,
                          "status",
                          this.state.statussortOrder,
                          ""
                        )}
                      >
                        {languageConfig[this.state.default_lang].status}{" "}
                        <i className={this.state.statusIconCur} />
                      </th>
                      <th>{languageConfig[this.state.default_lang].action}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {!isEmpty(this.state.voucherListArchive) ? (
                      this.state.voucherListArchive.map((list, index) => (
                        <tr key={Math.random()}>
                          <td>{vArchive++}</td>
                          <td>
                            <b>{list.merchantName}</b>
                            <br />#{list.voucherNumber}
                            <br />
                            {this.state.default_lang == 'en' ? list.dealText : list.french_dealText}
                          </td>
                          <td>
                            {list.never_expires && list.never_expires == "1"
                              ? languageConfig[this.state.default_lang]
                                  .never_expires
                              : moment(list.expiryDate).format("ll")}
                          </td>
                          <td>
                            {list.redeemed_at
                              ? moment(list.redeemed_at).format("ll")
                              : languageConfig[this.state.default_lang]
                                  .not_redeemed}
                          </td>
                          <td>
                            <Currency
                              amount={list.voucherValue}
                              default_lang={this.state.default_lang}
                              className="price"
                              default_currency={this.state.currency}
                            />
                          </td>
                          <td>
                            {list.voucher_status === "Redeemed"
                              ? languageConfig[this.state.default_lang].redeemed
                              : list.voucher_status}
                          </td>
                          <td>
                            <Button onClick={() => this.printarchiveVoucher(list)}>
                              <i className="glyphicon glyphicon-print" />{" "}
                              {languageConfig[this.state.default_lang].print}
                            </Button>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="7">
                          {
                            languageConfig[this.state.default_lang]
                              .data_not_found
                          }
                        </td>
                      </tr>
                    )}
                  </tbody>
                </Table>
                <div className="text-center">

                  <Pagination
                    total={totalRecordsArchive}
                    limit={perPage}
                    pageCount={5}
                    currentPage={ccurrentPage}
                  >
                    {({
                      pages,
                      currentPage,
                      hasNextPage,
                      hasPreviousPage,
                      previousPage,
                      nextPage,
                      totalPages,
                      getPageItemProps,
                    }) => (
                      <div className="pagination">
                        <button
                          {...getPageItemProps({
                            pageValue: 1,
                            onPageChange: this.handleVoucherArchivePageChange,
                          })}
                        >
                          {languageConfig[this.state.default_lang].first_button}
                        </button>

                        {hasPreviousPage && (
                          <button
                            {...getPageItemProps({
                              pageValue: previousPage,
                              onPageChange: this.handleVoucherArchivePageChange,
                            })}
                          >
                            {"<"}
                          </button>
                        )}

                        {pages.map((page) => {
                          let activePage = null;
                          if (currentPage === page) {
                            activePage = {
                              backgroundColor: "#ccc",
                              color: "#666",
                            };
                          }
                          return (
                            <button
                              key={page}
                              style={activePage}
                              {...getPageItemProps({
                                pageValue: page,
                                onPageChange: this.handleVoucherArchivePageChange,
                              })}
                            >
                              {page}
                            </button>
                          );
                        })}

                        {hasNextPage && (
                          <button
                            {...getPageItemProps({
                              pageValue: nextPage,
                              onPageChange: this.handleVoucherArchivePageChange,
                            })}
                          >
                            {">"}
                          </button>
                        )}

                        <button
                          {...getPageItemProps({
                            pageValue: totalPages,
                            onPageChange: this.handleVoucherArchivePageChange,
                          })}
                        >
                          {languageConfig[this.state.default_lang].last_button}
                        </button>
                      </div>
                    )}
                  </Pagination>
                  
                  {/**end archived voucher**/}
                </div>
              </Tab>

              <Tab
                eventKey={2}
                title={languageConfig[this.state.default_lang].my_coupans}
              >
              <div className="col-lg-3 col-md-4 col-sm-12 pull-right">
                  <FormGroup>
                    <InputGroup>
                      <FormControl
                        type="text"
                        name="coupon"
                               onKeyUp={this.handleSearch}
                       
                       placeholder={languageConfig[this.state.default_lang].voucherstextplace}
                      />
                      <InputGroup.Addon>
                        <Glyphicon glyph="glyphicon glyphicon-search" />
                      </InputGroup.Addon>
                    </InputGroup>
                  </FormGroup>
                </div>
                <Table striped bordered condensed hover>
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>
                        {languageConfig[this.state.default_lang].merchant_offer}
                      </th>
                      <th>
                        <th
                          onClick={this.sorting.bind(
                            this,
                            "expiration",
                            this.state.merchantNamesortOrder,
                            "direct"
                          )}
                        >
                          {languageConfig[this.state.default_lang].expiration}{" "}
                          <i className={this.state.merchantNameIconCur} />
                        </th>
                      </th>
                      <th
                        onClick={this.sorting.bind(
                          this,
                          "redeem_date",
                          this.state.redeemdatesortOrder,
                          "direct"
                        )}
                      >
                        {languageConfig[this.state.default_lang].redeem_date}{" "}
                        <i className={this.state.redeemDateIconCur} />
                      </th>
                      <th>
                        {languageConfig[this.state.default_lang].redeem_value}
                      </th>
                      <th
                        onClick={this.sorting.bind(
                          this,
                          "status",
                          this.state.statussortOrder,
                          "direct"
                        )}
                      >
                        {languageConfig[this.state.default_lang].status}{" "}
                        <i className={this.state.statusIconCur} />
                      </th>
                      <th>{languageConfig[this.state.default_lang].action}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {!isEmpty(this.state.couponList) ? (
                      this.state.couponList.map((list, index) => (
                        <tr key={Math.random()}>
                          <td>{c++}</td>
                          <td>
                            <b>{list.merchantName}</b>
                            <br />#{list.voucherNumber}
                            <br />
                            {list.dealText}
                          </td>
                          <td>{moment(list.expiryDate).format("ll")}</td>
                          <td>
                            {list.redeemed_at
                              ? moment(list.redeemed_at).format("ll")
                              : "Not Redeemed"}
                          </td>
                          <td>
                            <Currency
                              amount={list.voucherValue}
                              default_lang={this.state.default_lang}
                              className="price"
                              default_currency={this.state.currency}
                            />
                          </td>
                          <td>{list.voucher_status}</td>
                          <td>
                            <Button onClick={() => this.printVoucher(list)}>
                              <i className="glyphicon glyphicon-print" />{" "}
                              {languageConfig[this.state.default_lang].print}
                            </Button>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="7">
                          {
                            languageConfig[this.state.default_lang]
                              .data_not_found
                          }
                        </td>
                      </tr>
                    )}
                  </tbody>
                </Table>
                <div className="text-center">
                  <Pagination
                    total={ctotalRecords}
                    limit={cperPage}
                    pageCount={5}
                    currentPage={ccurrentPage}
                  >
                    {({
                      pages,
                      currentPage,
                      hasNextPage,
                      hasPreviousPage,
                      previousPage,
                      nextPage,
                      totalPages,
                      getPageItemProps,
                    }) => (
                      <div className="pagination">
                        <button
                          {...getPageItemProps({
                            pageValue: 1,
                            onPageChange: this.handleCoupanPageChange,
                          })}
                        >
                          {languageConfig[this.state.default_lang].first_button}
                        </button>

                        {hasPreviousPage && (
                          <button
                            {...getPageItemProps({
                              pageValue: previousPage,
                              onPageChange: this.handleCoupanPageChange,
                            })}
                          >
                            {"<"}
                          </button>
                        )}

                        {pages.map((page) => {
                          let activePage = null;
                          if (currentPage === page) {
                            activePage = {
                              backgroundColor: "#ccc",
                              color: "#666",
                            };
                          }
                          return (
                            <button
                              key={page}
                              style={activePage}
                              {...getPageItemProps({
                                pageValue: page,
                                onPageChange: this.handleCoupanPageChange,
                              })}
                            >
                              {page}
                            </button>
                          );
                        })}

                        {hasNextPage && (
                          <button
                            {...getPageItemProps({
                              pageValue: nextPage,
                              onPageChange: this.handleCoupanPageChange,
                            })}
                          >
                            {">"}
                          </button>
                        )}

                        <button
                          {...getPageItemProps({
                            pageValue: totalPages,
                            onPageChange: this.handleCoupanPageChange,
                          })}
                        >
                          {languageConfig[this.state.default_lang].last_button}
                        </button>
                      </div>
                    )}
                  </Pagination>
                </div>
              </Tab>
              <Tab
                eventKey={8}
                title={languageConfig[this.state.default_lang].mailed}
              >
               <div className="col-lg-3 col-md-4 col-sm-12 pull-right">
                  <FormGroup>
                    <InputGroup>
                      <FormControl
                        type="text"
                        name="mailed"
                               onKeyUp={this.handleSearch}
                       
                       placeholder={languageConfig[this.state.default_lang].voucherstextplace}
                      />
                      <InputGroup.Addon>
                        <Glyphicon glyph="glyphicon glyphicon-search" />
                      </InputGroup.Addon>
                    </InputGroup>
                  </FormGroup>
                </div>
                <Table striped bordered condensed hover>
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>
                        {languageConfig[this.state.default_lang].merchant_offer}
                      </th>
                      <th
                        onClick={this.sorting.bind(
                          this,
                          "expiration",
                          this.state.merchantNamesortOrder,
                          "non_shipable"
                        )}
                      >
                        {languageConfig[this.state.default_lang].expiration}{" "}
                        <i className={this.state.merchantNameIconCur} />
                      </th>
                      <th
                        onClick={this.sorting.bind(
                          this,
                          "redeem_date",
                          this.state.redeemdatesortOrder,
                          "non_shipable"
                        )}
                      >
                        {languageConfig[this.state.default_lang].redeem_date}{" "}
                        <i className={this.state.redeemDateIconCur} />
                      </th>

                      <th>
                        {languageConfig[this.state.default_lang].redeem_value}
                      </th>

                      <th
                        onClick={this.sorting.bind(
                          this,
                          "status",
                          this.state.statussortOrder,
                          "non_shipable"
                        )}
                      >
                        {languageConfig[this.state.default_lang].status}{" "}
                        <i className={this.state.statusIconCur} />
                      </th>
                      <th>{languageConfig[this.state.default_lang].action}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {!isEmpty(this.state.mailedList) ? (
                      this.state.mailedList.map((list, index) => (
                        <tr key={Math.random()}>
                          <td>{m++}</td>
                          <td>
                            <b>{list.merchantName}</b>
                            <br />#{list.voucherNumber}
                            <br />
                            {list.dealText}
                          </td>
                          <td>
  {moment(list.expiryDate).isValid()
    ? moment(list.expiryDate).format("ll")
    : "Never Expire"}
</td>

                          <td>
                            {list.trackingUploadedAt
                              ? "Tracking Uploaded At " +
                                moment(list.trackingUploadedAt).format("ll")
                              : list.redeemed_at
                              ? moment(list.redeemed_at).format("ll")
                              : "Not Redeemed"}
                          </td>
                          <td>
                            <Currency
                              amount={list.voucherValue}
                              default_lang={this.state.default_lang}
                              className="price"
                              default_currency={this.state.currency}
                            />
                          </td>
                          <td>
                            {list.trackingNumber
                              ? languageConfig[this.state.default_lang].mailed
                              : list.voucher_status}
                          </td>
                          <td>
                            <Button onClick={() => this.printVoucher(list)}>
                              <i className="glyphicon glyphicon-print" />{" "}
                              {languageConfig[this.state.default_lang].print}
                            </Button>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="7">
                          {
                            languageConfig[this.state.default_lang]
                              .data_not_found
                          }
                        </td>
                      </tr>
                    )}
                  </tbody>
                </Table>
                <div className="text-center">
                  <Pagination
                    total={mailedtotalRecords}
                    limit={mailedperPage}
                    pageCount={5}
                    currentPage={ccurrentPage}
                  >
                    {({
                      pages,
                      currentPage,
                      hasNextPage,
                      hasPreviousPage,
                      previousPage,
                      nextPage,
                      totalPages,
                      getPageItemProps,
                    }) => (
                      <div className="pagination">
                        <button
                          {...getPageItemProps({
                            pageValue: 1,
                            onPageChange: this.handleMailedPageChange,
                          })}
                        >
                          {languageConfig[this.state.default_lang].first_button}
                        </button>

                        {hasPreviousPage && (
                          <button
                            {...getPageItemProps({
                              pageValue: previousPage,
                              onPageChange: this.handleMailedPageChange,
                            })}
                          >
                            {"<"}
                          </button>
                        )}

                        {pages.map((page) => {
                          let activePage = null;
                          if (currentPage === page) {
                            activePage = {
                              backgroundColor: "#ccc",
                              color: "#666",
                            };
                          }
                          return (
                            <button
                              key={page}
                              style={activePage}
                              {...getPageItemProps({
                                pageValue: page,
                                onPageChange: this.handleMailedPageChange,
                              })}
                            >
                              {page}
                            </button>
                          );
                        })}

                        {hasNextPage && (
                          <button
                            {...getPageItemProps({
                              pageValue: nextPage,
                              onPageChange: this.handleMailedPageChange,
                            })}
                          >
                            {">"}
                          </button>
                        )}

                        <button
                          {...getPageItemProps({
                            pageValue: totalPages,
                            onPageChange: this.handleMailedPageChange,
                          })}
                        >
                          {languageConfig[this.state.default_lang].last_button}
                        </button>
                      </div>
                    )}
                  </Pagination>
                </div>
              </Tab>
              <Tab
                eventKey={9}
                title={languageConfig[this.state.default_lang].gift_cards}
              >

              <div className="col-lg-3 col-md-4 col-sm-12 pull-right">
                  <FormGroup>
                    <InputGroup>
                      <FormControl
                        type="text"
                        name="giftcards"
                               onKeyUp={this.handleSearch}
                       
                       placeholder={languageConfig[this.state.default_lang].voucherstextplace}
                      />
                      <InputGroup.Addon>
                        <Glyphicon glyph="glyphicon glyphicon-search" />
                      </InputGroup.Addon>
                    </InputGroup>
                  </FormGroup>
                </div>
                <Table striped bordered condensed hover>
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>
                        {languageConfig[this.state.default_lang].merchant_offer}
                      </th>
                      <th
                        onClick={this.sorting.bind(
                          this,
                          "expiration",
                          this.state.merchantNamesortOrder,
                          "gift_card"
                        )}
                      >
                        {languageConfig[this.state.default_lang].expiration}{" "}
                        <i className={this.state.merchantNameIconCur} />
                      </th>

                      <th
                        onClick={this.sorting.bind(
                          this,
                          "redeem_date",
                          this.state.redeemdatesortOrder,
                          "gift_card"
                        )}
                      >
                        {languageConfig[this.state.default_lang].redeem_date}{" "}
                        <i className={this.state.redeemDateIconCur} />
                      </th>
                      <th>
                        {languageConfig[this.state.default_lang].redeem_value}
                      </th>
                      <th
                        onClick={this.sorting.bind(
                          this,
                          "status",
                          this.state.statussortOrder,
                          "gift_card"
                        )}
                      >
                        {languageConfig[this.state.default_lang].status}{" "}
                        <i className={this.state.statusIconCur} />
                      </th>
                      <th>{languageConfig[this.state.default_lang].action}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {!isEmpty(this.state.giftList) ? (
                      this.state.giftList.map((list, index) => (
                        <tr key={Math.random()}>
                          <td>{g++}</td>
                          <td>
                            <b>{list.merchantName}</b>
                            <br />#{list.voucherNumber}
                            <br />
                            {list.dealText}
                          </td>
                          <td>  {moment(list.expiryDate).isValid()
    ? moment(list.expiryDate).format("ll")
    : "Never Expire"}</td>
                          <td>
                            {list.redeemed_at
                              ? moment(list.redeemed_at).format("ll")
                              : "Not Redeemed"}
                          </td>
                          <td>
                            <Currency
                              amount={list.voucherValue}
                              default_lang={this.state.default_lang}
                              className=""
                              default_currency={this.state.currency}
                            />
                          </td>
                          <td>{list.voucher_status}</td>
                          <td>
                            <Button onClick={() => this.printVoucher(list)}>
                              <i className="glyphicon glyphicon-print" />{" "}
                              {languageConfig[this.state.default_lang].print}
                            </Button>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="7">
                          {
                            languageConfig[this.state.default_lang]
                              .data_not_found
                          }
                        </td>
                      </tr>
                    )}
                  </tbody>
                </Table>
                <div className="text-center">
                  <Pagination
                    total={gifttotalRecords}
                    limit={giftperPage}
                    pageCount={5}
                    currentPage={ccurrentPage}
                  >
                    {({
                      pages,
                      currentPage,
                      hasNextPage,
                      hasPreviousPage,
                      previousPage,
                      nextPage,
                      totalPages,
                      getPageItemProps,
                    }) => (
                      <div className="pagination">
                        <button
                          {...getPageItemProps({
                            pageValue: 1,
                            onPageChange: this.handleGiftPageChange,
                          })}
                        >
                          {languageConfig[this.state.default_lang].first_button}
                        </button>

                        {hasPreviousPage && (
                          <button
                            {...getPageItemProps({
                              pageValue: previousPage,
                              onPageChange: this.handleGiftPageChange,
                            })}
                          >
                            {"<"}
                          </button>
                        )}

                        {pages.map((page) => {
                          let activePage = null;
                          if (currentPage === page) {
                            activePage = {
                              backgroundColor: "#ccc",
                              color: "#666",
                            };
                          }
                          return (
                            <button
                              key={page}
                              style={activePage}
                              {...getPageItemProps({
                                pageValue: page,
                                onPageChange: this.handleGiftPageChange,
                              })}
                            >
                              {page}
                            </button>
                          );
                        })}

                        {hasNextPage && (
                          <button
                            {...getPageItemProps({
                              pageValue: nextPage,
                              onPageChange: this.handleGiftPageChange,
                            })}
                          >
                            {">"}
                          </button>
                        )}

                        <button
                          {...getPageItemProps({
                            pageValue: totalPages,
                            onPageChange: this.handleGiftPageChange,
                          })}
                        >
                          {languageConfig[this.state.default_lang].last_button}
                        </button>
                      </div>
                    )}
                  </Pagination>
                </div>
              </Tab>
              <Tab
                eventKey={10}
                title={languageConfig[this.state.default_lang].generated}
              >
                <div className="col-lg-3 col-md-4 col-sm-12 pull-right">
                  <FormGroup>
                    <InputGroup>
                      <FormControl
                        type="text"
                        name="generate_voucher"
                               onKeyUp={this.handleSearch}
                       
                       placeholder={languageConfig[this.state.default_lang].voucherstextplace}
                      />
                      <InputGroup.Addon>
                        <Glyphicon glyph="glyphicon glyphicon-search" />
                      </InputGroup.Addon>
                    </InputGroup>
                  </FormGroup>
                </div>
                <Table striped bordered condensed hover>
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>
                        {languageConfig[this.state.default_lang].merchant_offer}
                      </th>
                      <th
                        onClick={this.sorting.bind(
                          this,
                          "expiration",
                          this.state.merchantNamesortOrder,
                          "generate_voucher"
                        )}
                      >
                        {languageConfig[this.state.default_lang].expiration}{" "}
                        <i className={this.state.merchantNameIconCur} />
                      </th>
                      <th
                        onClick={this.sorting.bind(
                          this,
                          "redeem_date",
                          this.state.redeemdatesortOrder,
                          "generate_voucher"
                        )}
                      >
                        {languageConfig[this.state.default_lang].redeem_date}{" "}
                        <i className={this.state.redeemDateIconCur} />
                      </th>

                      <th>
                        {languageConfig[this.state.default_lang].redeem_value}
                      </th>
                      <th
                        onClick={this.sorting.bind(
                          this,
                          "status",
                          this.state.statussortOrder,
                          "generate_voucher"
                        )}
                      >
                        {languageConfig[this.state.default_lang].status}{" "}
                        <i className={this.state.statusIconCur} />
                      </th>
                      <th>{languageConfig[this.state.default_lang].action}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {!isEmpty(this.state.generatedList) ? (
                      this.state.generatedList.map((list, index) => (
                        <tr key={Math.random()}>
                          <td>{gn++}</td>
                          <td>
                            <b>{list.merchantName}</b>
                            <br />#{list.voucherNumber}
                            <br />
                            {list.dealText}
                          </td>
                          <td>  {moment(list.expiryDate).isValid()
    ? moment(list.expiryDate).format("ll")
    : "Never Expire"}</td>
                          <td>
                            {list.redeemed_at
                              ? moment(list.redeemed_at).format("ll")
                              : "Not Redeemed"}
                          </td>
                          <td>
                            <Currency
                              amount={list.voucherValue}
                              default_lang={this.state.default_lang}
                              className=""
                              default_currency={this.state.currency}
                            />
                          </td>
                          <td>{list.voucher_status}</td>
                          <td>
                            <Button onClick={() => this.printVoucher(list)}>
                              <i className="glyphicon glyphicon-print" />{" "}
                              {languageConfig[this.state.default_lang].print}
                            </Button>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="7">
                          {
                            languageConfig[this.state.default_lang]
                              .data_not_found
                          }
                        </td>
                      </tr>
                    )}
                  </tbody>
                </Table>
                <div className="text-center">
                  <Pagination
                    total={generatedtotalRecords}
                    limit={generatedperPage}
                    pageCount={5}
                    currentPage={ccurrentPage}
                  >
                    {({
                      pages,
                      currentPage,
                      hasNextPage,
                      hasPreviousPage,
                      previousPage,
                      nextPage,
                      totalPages,
                      getPageItemProps,
                    }) => (
                      <div className="pagination">
                        <button
                          {...getPageItemProps({
                            pageValue: 1,
                            onPageChange: this.handleGeneratedPageChange,
                          })}
                        >
                          {languageConfig[this.state.default_lang].first_button}
                        </button>

                        {hasPreviousPage && (
                          <button
                            {...getPageItemProps({
                              pageValue: previousPage,
                              onPageChange: this.handleGeneratedPageChange,
                            })}
                          >
                            {"<"}
                          </button>
                        )}

                        {pages.map((page) => {
                          let activePage = null;
                          if (currentPage === page) {
                            activePage = {
                              backgroundColor: "#ccc",
                              color: "#666",
                            };
                          }
                          return (
                            <button
                              key={page}
                              style={activePage}
                              {...getPageItemProps({
                                pageValue: page,
                                onPageChange: this.handleGeneratedPageChange,
                              })}
                            >
                              {page}
                            </button>
                          );
                        })}

                        {hasNextPage && (
                          <button
                            {...getPageItemProps({
                              pageValue: nextPage,
                              onPageChange: this.handleGeneratedPageChange,
                            })}
                          >
                            {">"}
                          </button>
                        )}

                        <button
                          {...getPageItemProps({
                            pageValue: totalPages,
                            onPageChange: this.handleGeneratedPageChange,
                          })}
                        >
                          {languageConfig[this.state.default_lang].last_button}
                        </button>
                      </div>
                    )}
                  </Pagination>
                </div>
              </Tab>
              <Tab
                eventKey={7}
                title={languageConfig[this.state.default_lang].order_detail}
              >

               <div className="col-lg-3 col-md-4 col-sm-12 pull-right">
                  <FormGroup>
                    <InputGroup>
                      <FormControl
                        type="text"
                        name="generate_voucher"
                               onKeyUp={this.handleOrderSearch}
                       
                       placeholder="Merchant Name or Offer Name"
                      />
                      <InputGroup.Addon>
                        <Glyphicon glyph="glyphicon glyphicon-search" />
                      </InputGroup.Addon>
                    </InputGroup>
                  </FormGroup>
                </div>  
                <Table striped bordered condensed hover>
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>
                        {languageConfig[this.state.default_lang].merchant_offer}
                      </th>
                      <th>{languageConfig[this.state.default_lang].offer}</th>
                      <th>
                        {languageConfig[this.state.default_lang].amount_charged}
                      </th>
                      <th>
                        {languageConfig[this.state.default_lang].credit_used}
                      </th>
                      <th>
                        {languageConfig[this.state.default_lang].placed_on}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {!isEmpty(this.state.orderList) ? (
                      this.state.orderList.map((list, index) => (
                        <tr key={Math.random()}>
                          <td>{o++}</td>
                          <td>{list.merchantName}</td>
                          <td>{list.dealText}</td>
                          <td>
                            <Currency
                              amount={list.amount_charged}
                              default_lang={this.state.default_lang}
                              className=""
                              default_currency={this.state.currency}
                            />
                          </td>
                          <td>
                            <Currency
                              amount={
                                list.store_credit_used
                                  ? list.store_credit_used
                                  : "0"
                              }
                              default_lang={this.state.default_lang}
                              className=""
                              default_currency={this.state.currency}
                            />
                          </td>
                          <td>{moment(list.placed_on).format("ll")}</td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="6">
                          {
                            languageConfig[this.state.default_lang]
                              .data_not_found
                          }
                        </td>
                      </tr>
                    )}
                  </tbody>
                </Table>
                <div className="text-center">
                  <Pagination
                    total={totalOrderRecords}
                    limit={perOrderPage}
                    pageCount={5}
                    currentPage={ccurrentPage}
                  >
                    {({
                      pages,
                      currentPage,
                      hasNextPage,
                      hasPreviousPage,
                      previousPage,
                      nextPage,
                      totalPages,
                      getPageItemProps,
                    }) => (
                      <div className="pagination">
                        <button
                          {...getPageItemProps({
                            pageValue: 1,
                            onPageChange: this.handleOrderPageChange,
                          })}
                        >
                          {languageConfig[this.state.default_lang].first_button}
                        </button>

                        {hasPreviousPage && (
                          <button
                            {...getPageItemProps({
                              pageValue: previousPage,
                              onPageChange: this.handleOrderPageChange,
                            })}
                          >
                            {"<"}
                          </button>
                        )}

                        {pages.map((page) => {
                          let activePage = null;
                          if (currentPage === page) {
                            activePage = {
                              backgroundColor: "#ccc",
                              color: "#666",
                            };
                          }
                          return (
                            <button
                              key={page}
                              style={activePage}
                              {...getPageItemProps({
                                pageValue: page,
                                onPageChange: this.handleOrderPageChange,
                              })}
                            >
                              {page}
                            </button>
                          );
                        })}

                        {hasNextPage && (
                          <button
                            {...getPageItemProps({
                              pageValue: nextPage,
                              onPageChange: this.handleOrderPageChange,
                            })}
                          >
                            {">"}
                          </button>
                        )}

                        <button
                          {...getPageItemProps({
                            pageValue: totalPages,
                            onPageChange: this.handleOrderPageChange,
                          })}
                        >
                          {languageConfig[this.state.default_lang].last_button}
                        </button>
                      </div>
                    )}
                  </Pagination>
                </div>
              </Tab>
              <Tab
                eventKey={4}
                title={languageConfig[this.state.default_lang].edit_profile}
              >
                {/*****Start Form for user profile */}
                <form onSubmit={this.handleSubmit}>
                  <Row>
                    <Col md={8} xs={12}>
                      <Row>
                        <Col md={6} xs={12}>
                          <FormGroup>
                            <ControlLabel>
                              {
                                languageConfig[this.state.default_lang]
                                  .first_name
                              }{" "}
                              <span style={{ color: "red" }}>*</span>
                            </ControlLabel>
                            <FormControl
                              type="text"
                              value={
                                this.state.firstName ? this.state.firstName : ""
                              }
                              placeholder={
                                languageConfig[this.state.default_lang]
                                  .enter_first_name
                              }
                              onChange={this.handleChange}
                              style={{
                                borderColor: this.state.firstNameError,
                              }}
                              name="firstName"
                              autoComplete="off"
                            />
                          </FormGroup>
                        </Col>

                        <Col md={6} xs={12}>
                          <FormGroup>
                            <ControlLabel>
                              {
                                languageConfig[this.state.default_lang]
                                  .last_name
                              }{" "}
                              <span style={{ color: "red" }}>*</span>
                            </ControlLabel>
                            <FormControl
                              type="text"
                              value={
                                this.state.lastName ? this.state.lastName : ""
                              }
                              placeholder={
                                languageConfig[this.state.default_lang]
                                  .enter_last_name
                              }
                              onChange={this.handleChange}
                              style={{
                                borderColor: this.state.lastNameError,
                              }}
                              name="lastName"
                              autoComplete="off"
                            />
                          </FormGroup>
                        </Col>
                      </Row>
                      <Row>
                        <Col md={6} xs={12}>
                          <ControlLabel>
                            {languageConfig[this.state.default_lang].email}{" "}
                            <span style={{ color: "red" }}>*</span>
                          </ControlLabel>
                          <FormGroup
                            controlId="email"
                            validationState={this.getValidationEmailState()}
                          >
                            <FormControl
                              type="text"
                              value={this.state.email ? this.state.email : ""}
                              placeholder={
                                languageConfig[this.state.default_lang]
                                  .enter_email
                              }
                              onChange={this.handleChange}
                              style={{
                                borderColor: this.state.emailError,
                              }}
                              name="email"
                              autoComplete="off"
                            />
                          </FormGroup>
                        </Col>
                           {(this.state.enabled == '0') &&
                        <Col md={6} xs={12}>
                          <FormGroup>
                            <FormGroup controlId="gender">
                              <ControlLabel>
                                {languageConfig[this.state.default_lang].gender}
                              </ControlLabel>
                              <FormControl
                                name="gender"
                                style={{
                                  borderColor: this.state.genderError,
                                }}
                                value={
                                  this.state.gender ? this.state.gender : ""
                                }
                                componentClass="select"
                                onChange={this.handleChange}
                              >
                                <option value="Male">Male</option>
                                <option value="Female">Female</option>
                                        
                              </FormControl>
                            </FormGroup>
                          </FormGroup>
                        </Col>
                      }
                      </Row>
                      <Row>
                        <Col md={6} xs={12}>
                          <FormGroup>
                            <ControlLabel>
                              {
                                languageConfig[this.state.default_lang]
                                  .date_birth
                              }{" "}
                            </ControlLabel>
                            <br />
                            <DatePicker
                              onChange={this.onChangeStartDate}
                              value={this.state.dob}
                              className={this.state.dobError ? "error" : ""}
                            />
                          </FormGroup>
                        </Col>
                        <Col md={6} xs={12}>
                          <FormGroup>
                            <ControlLabel>
                              {languageConfig[this.state.default_lang].address}{" "}
                            </ControlLabel>
                            <FormControl
                              type="text"
                              value={
                                this.state.address1 ? this.state.address1 : ""
                              }
                              placeholder={
                                languageConfig[this.state.default_lang].address
                              }
                              onChange={this.handleChange}
                              style={{
                                borderColor: this.state.address1Error,
                              }}
                              name="address1"
                              autoComplete="off"
                            />
                          </FormGroup>
                        </Col>
                      </Row>
                      <Row>
                        <Col md={6} xs={12}>
                          <FormGroup>
                            <FormGroup controlId="addresss2">
                              <ControlLabel>
                                {
                                  languageConfig[this.state.default_lang]
                                    .address2
                                }
                              </ControlLabel>
                              <FormControl
                                type="text"
                                value={
                                  this.state.address2 ? this.state.address2 : ""
                                }
                                placeholder={
                                  languageConfig[this.state.default_lang]
                                    .address2
                                }
                                onChange={this.handleChange}
                                name="address2"
                                autoComplete="off"
                              />
                            </FormGroup>
                          </FormGroup>
                        </Col>
                        <Col md={6} xs={12}>
                          <FormGroup>
                            <FormGroup controlId="zip">
                              <ControlLabel>
                                {
                                  languageConfig[this.state.default_lang]
                                    .zip_code
                                }
                              </ControlLabel>
                              <FormControl
                                type="text"
                                value={
                                  this.state.zipcode ? this.state.zipcode : ""
                                }
                                placeholder={
                                  languageConfig[this.state.default_lang]
                                    .zip_code
                                }
                                onChange={this.handleChange}
                                name="zipcode"
                                autoComplete="off"
                              />
                            </FormGroup>
                          </FormGroup>
                        </Col>
                      </Row>
                    </Col>
                    <Col md={4} xs={12}>
                      <FormGroup>
                        <FormGroup controlId="country">
                          <ControlLabel>
                            {languageConfig[this.state.default_lang].country}{" "}
                            <span style={{ color: "red" }}>*</span>
                          </ControlLabel>
                          <FormControl
                            type="text"
                            value={this.state.country ? this.state.country : ""}
                            placeholder={
                              languageConfig[this.state.default_lang].country
                            }
                            onChange={this.handleChange}
                            name="country"
                            autoComplete="off"
                            style={{ borderColor: this.state.countryError }}
                          />
                        </FormGroup>
                      </FormGroup>
                    </Col>
                    <Col md={4} xs={12}>
                      <FormGroup>
                        <FormGroup controlId="state">
                          <ControlLabel>
                            {languageConfig[this.state.default_lang].state}{" "}
                            <span style={{ color: "red" }}>*</span>
                          </ControlLabel>
                          <FormControl
                            type="text"
                            value={this.state.state ? this.state.state : ""}
                            placeholder={
                              languageConfig[this.state.default_lang].state
                            }
                            onChange={this.handleChange}
                            name="state"
                            autoComplete="off"
                            style={{ borderColor: this.state.stateError }}
                          />
                        </FormGroup>
                      </FormGroup>
                    </Col>
                    <Col md={4} xs={12}>
                      <FormGroup>
                        <FormGroup controlId="addCity">
                          <ControlLabel>
                            {languageConfig[this.state.default_lang].city}{" "}
                            <span style={{ color: "red" }}>*</span>
                          </ControlLabel>
                          <FormControl
                            type="text"
                            value={this.state.addCity ? this.state.addCity : ""}
                            placeholder={
                              languageConfig[this.state.default_lang].city
                            }
                            onChange={this.handleChange}
                            name="addCity"
                            autoComplete="off"
                            style={{ borderColor: this.state.addCityError }}
                          />
                        </FormGroup>
                      </FormGroup>
                    </Col>
                    <Col md={4} xs={12}>
                      <FormGroup>
                        <ControlLabel>
                          {
                            languageConfig[this.state.default_lang]
                              .subscriber_city
                          }{" "}
                          <span style={{ color: "red" }}>*</span>
                        </ControlLabel>
                        <FormControl
                          style={{ borderColor: this.state.cityIDError }}
                          componentClass="select"
                          name="cityID"
                          value={this.state.cityID}
                          placeholder="select"
                          onChange={this.handleChange}
                        >
                          <option value="">
                            {
                              languageConfig[this.state.default_lang]
                                .choose_region
                            }
                          </option>
                          {this.state.cityList &&
                            this.state.cityList.map((data, index) => (
                              <optgroup
                                key={"hcity" + index}
                                label={data.country}
                              >
                                {data.cities &&
                                  data.cities.map((city, index) => (
                                    <option
                                      key={"hcityval" + index}
                                      value={city.cityID}
                                    >
                                      {city.title}
                                    </option>
                                  ))}
                              </optgroup>
                            ))}
                        </FormControl>
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col md={6} xs={12}>
                      <FormGroup>
                        <ControlLabel>
                          {languageConfig[this.state.default_lang].phone_no}{" "}
                        </ControlLabel>
                        <NumberFormat
                          format="###-###-####"
                          mask="_"
                          className="form-control"
                          name="phone"
                          placeholder={
                            languageConfig[this.state.default_lang].phone_no
                          }
                          value={this.state.phone}
                          onChange={this.handleChange}
                          autoComplete="off"
                          style={{ borderColor: this.state.phoneError }}
                        />
                      </FormGroup>
                    </Col>

                    {this.state.charityOption == "enable" && (
                      <Col md={4} xs={4} className="charity-dropdown">
                        <ControlLabel>
                          Charity:{this.state.charity_name}
                        </ControlLabel>
                        <br />
                        <ReactAutocomplete
                          inputProps={{
                            style: {
                              borderColor: this.state.userEmailError,
                              width: "100%",
                              height: "34px",
                              display: "block",
                              padding: "6px 12px",
                              border: "1px solid #ccc",
                            },
                          }}
                          items={this.state.charity ? this.state.charity : []}
                          shouldItemRender={(item, value) =>
                            item.charity_name
                              .toLowerCase()
                              .indexOf(value.toLowerCase()) > -1
                          }
                          getItemValue={(item) => item.charity_name}
                          renderItem={(item, highlighted) => (
                            <div
                              className="form-group"
                              key={item.charity_id}
                              data-key={item.charity_id}
                              style={{
                                backgroundColor: highlighted
                                  ? "#eee"
                                  : "transparent",
                              }}
                            >
                              {item.charity_name}
                            </div>
                          )}
                          value={this.state.charity_name}
                          onChange={this.onChangeCharity}
                          onSelect={(charity_name, item) =>
                            this.setState({
                              charity_name,
                              charity_id: item.charity_id,
                            })
                          }
                        />
                      </Col>
                    )}
                  </Row>
                  <br />
                  <Row>
                    <Col md={12} xs={12}>
                      <Button
                        bsStyle="success"
                        type="submit"
                        style={{
                          backgroundColor:
                            this.state.hover && this.state.hoverID == "register"
                              ? this.state.mouseover_color
                              : this.state.button_color
                              ? this.state.button_color
                              : "#77C84E",
                        }}
                        data-id={"register"}
                        onMouseEnter={this.hoverOn}
                        onMouseLeave={this.hoverOff}
                        disabled={this.state.disabled1}
                      >
                        {languageConfig[this.state.default_lang].update}
                      </Button>
                    </Col>
                  </Row>
                </form>
                <br />
                {this.state.card_data !== "" && this.state.check_card == 1 && (
                  <Row>
                    <Col md={12} xs={12}>
                      <b>Saved Card Detail</b>
                    </Col>
                    <Col md={12} xs={12}>
                      <hr />
                    </Col>
                    <Col md={12} xs={12}>
                      <Table striped bordered condensed hover>
                        <thead>
                          <tr>
                            <th>#</th>
                            <th>
                              {
                                languageConfig[this.state.default_lang]
                                  .card_number
                              }
                            </th>
                            <th>
                              {languageConfig[this.state.default_lang].action}
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {this.state.card_data !== "" &&
                          this.state.check_card == 1 ? (
                            this.state.card_data.map((card, index) => (
                              <tr key={Math.random()}>
                                <td>{++index}</td>
                                <td>
                                  {"XXXXXXXXXXXX" +
                                    card.cardNumber.toString().substr(-4)}
                                </td>
                                <td>
                                  <Button
                                    style={{
                                      backgroundColor:
                                        this.state.hover &&
                                        this.state.hoverID == "trash"
                                          ? this.state.mouseover_color
                                          : this.state.button_color,
                                    }}
                                    data-id={"trash"}
                                    onMouseEnter={this.hoverOn}
                                    onMouseLeave={this.hoverOff}
                                    bsStyle="danger"
                                    onClick={this.deleteCardDetail.bind(
                                      this,
                                      card.cardNumber
                                    )}
                                  >
                                    <i className="glyphicon glyphicon-trash" />
                                  </Button>
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="6">
                                {
                                  languageConfig[this.state.default_lang]
                                    .data_not_found
                                }
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </Table>
                    </Col>
                  </Row>
                )}
                {/*****End form for user profile*/}
              </Tab>
              <Tab
                eventKey={5}
                title={languageConfig[this.state.default_lang].change_password}
              >
                {/******Start Change Password********/}
                <form onSubmit={this.handlePasswordSubmit}>
                  <Row>
                    <Col md={12} xs={12}>
                      <Row>
                        <Col md={4} xs={12}>
                          <FormGroup>
                            <ControlLabel>
                              {
                                languageConfig[this.state.default_lang]
                                  .old_password
                              }
                            </ControlLabel>
                            <FormControl
                              type="password"
                              value={this.state.old_password}
                              onChange={this.handleChange}
                              name="old_password"
                              autoComplete="off"
                              style={{
                                borderColor: this.state.old_passwordError,
                              }}
                            />
                          </FormGroup>
                        </Col>

                        <Col md={4} xs={12}>
                          <FormGroup>
                            <ControlLabel>
                              {languageConfig[this.state.default_lang].password}{" "}
                            </ControlLabel>
                            <FormControl
                              type="password"
                              value={this.state.password}
                              onChange={this.handleChange}
                              name="password"
                              style={{
                                borderColor: this.state.passwordError,
                              }}
                              autoComplete="off"
                            />

<PasswordChecklist
				rules={["minLength","specialChar","number","capital","match"]}
				minLength={8}
				value={this.state.password}
				valueAgain={this.state.cpassword}
				
			/>
                         
                          </FormGroup>
                        </Col>
                        <Col md={4} xs={12}>
                          <FormGroup>
                            <ControlLabel>
                              {
                                languageConfig[this.state.default_lang]
                                  .confirm_password
                              }{" "}
                            </ControlLabel>
                            <FormControl
                              type="password"
                              value={this.state.cpassword}
                              onChange={this.handleChange}
                              name="cpassword"
                              style={{
                                borderColor: this.state.cpasswordError,
                              }}
                              autoComplete="off"
                            />
                          </FormGroup>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                  <Row>
                    <Col md={12} xs={12}>
                      <Button
                        bsStyle="success"
                        type="submit"
                        style={{
                          backgroundColor:
                            this.state.hover && this.state.hoverID == "register"
                              ? this.state.mouseover_color
                              : this.state.button_color
                              ? this.state.button_color
                              : "#77C84E",
                        }}
                        data-id={"register"}
                        onMouseEnter={this.hoverOn}
                        onMouseLeave={this.hoverOff}
                        disabled={this.state.disabled2}
                      >
                        {languageConfig[this.state.default_lang].update}
                      </Button>
                    </Col>
                  </Row>
                </form>
                {/******End Change Password*****/}
              </Tab>
              {this.state.referralStatus && (
                <Tab
                  eventKey={6}
                  title={languageConfig[this.state.default_lang].referral}
                >
                  {/******Start Referral********/}
                  {this.state.refferralresponse == "notAvailable" ? (
                    <div>
                      <ControlLabel>
                        {" "}
                        Referral settings not available.{" "}
                      </ControlLabel>
                    </div>
                  ) : this.state.refferralresponse == "enable" ? (
                    <form onSubmit={this.handleClipboard}>
                      <Row>
                        {this.state.dealresponse == "failed" ? (
                          <div>
                            <ControlLabel>
                              {" "}
                              Please make a purchase to receive a referral link.{" "}
                            </ControlLabel>
                          </div>
                        ) : (
                          <Col md={12} xs={12}>
                            <Row>
                              <Col md={6} xs={12}>
                                <FormGroup>
                                  <ControlLabel>
                                    {" "}
                                    {this.state.refferalhtml
                                      ? ReactHtmlParser(this.state.refferalhtml)
                                      : languageConfig[this.state.default_lang]
                                          .referral_link}{" "}
                                  </ControlLabel>
                                  <FormControl
                                    type="text"
                                    value={this.state.referral}
                                    //onChange={this.handleChange}
                                    onChange={({ target: { value } }) =>
                                      this.setState({ value, copied: false })
                                    }
                                    name="referral"
                                    autoComplete="off"
                                    readOnly
                                  />
                                </FormGroup>
                              </Col>
                            </Row>
                            <Row>
                              <Col md={12} xs={12}>
                                <CopyToClipboard
                                  text={this.state.referral}
                                  onCopy={this.onCopy.bind(this)}
                                >
                                  <button>
                                    {
                                      languageConfig[this.state.default_lang]
                                        .copy
                                    }
                                  </button>
                                </CopyToClipboard>
                              </Col>
                            </Row>
                            <Row>
                              <Col md={12} xs={12}>
                                <br />
                                <Table striped bordered condensed hover>
                                  <thead>
                                    <tr>
                                      <th>#</th>
                                      <th>Name</th>
                                      <th>Created On</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {!isEmpty(this.state.refferals) ? (
                                      this.state.refferals.map(
                                        (data, index) => (
                                          <tr key={`refferal${index}`}>
                                            <td>{++index}</td>
                                            <td>{data.name}</td>
                                            <td>{data.createdon}</td>
                                          </tr>
                                        )
                                      )
                                    ) : (
                                      <tr>
                                        <td colSpan="3">Data Not Found</td>
                                      </tr>
                                    )}
                                  </tbody>
                                </Table>
                              </Col>
                            </Row>
                          </Col>
                        )}
                      </Row>
                    </form>
                  ) : (
                    ""
                  )}
                  {/******End Referral*****/}
                </Tab>
              )}
            </Tabs>
          </div>
        </div>
      </div>
    );
  }
}

MyAccount.propTypes = {
  userVoucherList: PropTypes.func.isRequired,
  userVoucherListArchive: PropTypes.func.isRequired,
  userOrderList: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  error: state.frontReducer.error,
  voucherList: state.frontReducer.voucherList,
  voucherListArchive: state.frontReducer.voucherListArchive,
  orderList: state.frontReducer.orderList,
  custDetail: state.frontReducer.custDetail,
  alertType: state.alertsReducer.alertType,
  message: state.alertsReducer.message,
  profileStatus: state.frontReducer.profileStatus,
  passwordStatus: state.frontReducer.passwordStatus,
  userdealResponse: state.frontReducer.userdealResponse,
  creditAmount: state.frontReducer.creditAmount,
  cityList: state.frontReducer.cityList,
  couponList: state.frontReducer.couponList,
  refferals: state.frontReducer.refferals,
  card: state.frontReducer.card,
  mailedList: state.frontReducer.mailedList,
  giftList: state.frontReducer.giftList,
  generatedList: state.frontReducer.generatedList,
  getCharity: state.frontReducer.getCharity,
  orderRedeem: state.frontReducer.ordertracking,
    permission: state.frontReducer.becomePermission,
});

export default compose(
  connect(mapStateToProps, {
    voucherStatus,
    userVoucherList,
    userVoucherListArchive,
    renderAlert,
    clearAlert,
    userOrderList,
    changePassword,
    customerDetail,
    profileUpdate,
    checkUserDeal,
    storeCredit,
    getSiteCity,
    userCoupanList,
    getRefferals,
    delteCard,
    mailedOrderList,
    giftOrderList,
    generatedOrderList,
    getcharityList,
    partnerPermission,
  })
)(MyAccount);



// WEBPACK FOOTER //
// ./src/app/views/frontend/user/MyAccount.js